"use strict";
exports.__esModule = true;
exports.OPACITY = exports.SIZES = exports.COLORS = void 0;
exports.COLORS = {
    primary: 'bg-primary-300',
    danger: 'bg-danger-300',
    warning: 'bg-warning-300',
    secondary: 'bg-secondary-300',
    control: 'bg-control-300',
    tertiary: 'bg-tertiary-300',
    success: 'bg-success-300',
    info: 'bg-info-300',
    inherit: 'bg-primary-300',
    slate: 'bg-slate-300',
    zinc: 'bg-zinc-300',
    neutral: 'bg-neutral-300',
    stone: 'bg-stone-300',
    red: 'bg-red-300',
    orange: 'bg-orange-300',
    amber: 'bg-amber-300',
    yellow: 'bg-yellow-300',
    lime: 'bg-lime-300',
    green: 'bg-green-300',
    emerald: 'bg-emerald-300',
    teal: 'bg-teal-300',
    cyan: 'bg-cyan-300',
    sky: 'bg-sky-300',
    blue: 'bg-blue-300',
    indigo: 'bg-indigo-300',
    violet: 'bg-violet-300',
    purple: 'bg-purple-300',
    fuchsia: 'bg-fuchsia-300',
    pink: 'bg-pink-300',
    rose: 'bg-rose-300'
};
/**
 * @constructor
 */
exports.SIZES = {
    tiny: 'w-[60px] h-[60px] sm:w-[100px] sm:h-[100px] md:w-[160px] md:h-[160px]',
    small: 'w-[100px] h-[100px] sm:w-[140px] sm:h-[140px] md:w-[200px] md:h-[200px]',
    medium: 'w-[140px] h-[140px] sm:w-[160px] sm:h-[160px] md:w-[240px] md:h-[240px]',
    large: 'w-[160px] h-[160px] sm:w-[200px] sm:h-[200px] md:w-[300px] md:h-[300px]',
    huge: 'w-[200px] h-[200px] sm:w-[240px] sm:h-[240px] md:w-[360px] md:h-[360px]'
};
exports.OPACITY = {
    thin: 'opacity-5',
    low: 'opacity-10',
    medium: 'opacity-20',
    high: 'opacity-25'
};
//# sourceMappingURL=halo-color.style.js.map